module.exports = __webpack_public_path__ + "static/laboheme8-8e406ef0c1a1d7ccafa99b721dc368cc.jpg";